import Vue from "vue"

// components:
import Vuetify from "vuetify/lib"

// directives:
// import { Ripple } from "vuetify/lib/directives";

// locales
import fr from "vuetify/es5/locale/fr"

// styles
import "vuetify/src/stylus/app.styl"
import "material-design-icons-iconfont/dist/material-design-icons.css"

Vue.use(Vuetify, {
  iconfont: "md",

  lang: {
    locales: { fr },
    current: "fr",
  },

  theme: {
    primary: "#ff9d1c",
    secondary: "#657481",
  },

  // components: {
  //  VApp,
  // },

  // directives: {
  //  Ripple,
  // }
})
